import { __awaiter, __generator } from "tslib";
import { Duplexer } from '@wix/duplexer-js';
import { APP_DEF_ID, DUPLEXER_ENDPOINT } from '@wix/live-video-commons';
var DuplexerConnection = /** @class */ (function () {
    function DuplexerConnection(_a) {
        var channel = _a.channel, instanceUpdater = _a.instanceUpdater;
        var _this = this;
        this.ready = new Promise(function (resolve) {
            var duplexer = new Duplexer(DUPLEXER_ENDPOINT, {
                instanceUpdater: instanceUpdater,
            });
            _this.connection = duplexer.connect({ appDefId: APP_DEF_ID });
            _this.connection.on('@duplexer:connected', function () {
                var channelName = channel.channelName, resourceId = channel.resourceId;
                _this.channel = _this.connection.subscribe(channelName, {
                    resourceId: resourceId,
                });
                _this.channel.on('@duplexer:subscription_succeeded', function () {
                    resolve();
                });
            });
        });
    }
    DuplexerConnection.prototype.on = function (eventName, cb) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ready];
                    case 1:
                        _a.sent();
                        this.channel.on(eventName, cb);
                        return [2 /*return*/];
                }
            });
        });
    };
    DuplexerConnection.prototype.send = function (eventName, payload) {
        if (payload === void 0) { payload = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!eventName.startsWith('client-')) {
                            throw new Error('Client event must start with "client-"');
                        }
                        return [4 /*yield*/, this.ready];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.channel.send(eventName, payload)];
                }
            });
        });
    };
    DuplexerConnection.prototype.disconnect = function () {
        var _a, _b;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.off();
        (_b = this.connection) === null || _b === void 0 ? void 0 : _b.disconnect();
    };
    return DuplexerConnection;
}());
export { DuplexerConnection };
//# sourceMappingURL=duplexer.js.map